<template>
  <div class="login-box">
    <div class="login-box-readme">
      <img class="login-logo" src="../assets/logo.png" />
      <h1>个人&nbsp;&nbsp;聚合&nbsp;&nbsp;工具管理</h1>
      <h2>Myself Util book</h2>
      <h3>good good study! day day up!</h3>
    </div>
    <div class="login-box-main">
      <div class="submit-box">
        <span class="login-title">登录</span>
        <div class="login-input-box">
          <input class="login-input" type="text" placeholder="请输入用户名" />
        </div>
        <div class="login-input-box">
          <input class="login-input" type="password" placeholder="请输入密码" />
        </div>
        <span class="text-tips">忘记密码?</span>
        <input class="btn-submit" type="button" value="登录" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginView',
};
</script>

<style scoped>
.login-box {
  height: 100%;
  width: 100%;
  background-image: url('../assets/loginBackgorund.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.login-logo {
  width: 74px;
  height: 74px;
}
h1 {
  font-family: Montserrat;
  font-weight: 600;
  font-size: 84px;
  color: #f7ffff;
  margin: 148px 0px 64px 0px;
}
h2 {
  font-family: Montserrat;
  font-weight: 600;
  font-size: 42px;
  color: #f7ffff;
  background: linear-gradient(181deg, #73b8c3 0%, #d095c5 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0px 0px 66px 0px;
}
h3 {
  font-family: Montserrat;
  font-weight: 300;
  font-size: 23px;
  color: #f7ffff;
  margin: 0px 0px 59px 0px;
}
.login-box-readme {
  max-width: 636px;
}
.submit-box {
  width: 518px;
  height: 514px;
  border-radius: 30px;
  background-color: #0a1724;
  margin-left: 254px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 60px;
}
.login-title {
  display: inline-block;
  width: 100%;
  font-family: Montserrat;
  font-weight: 600;
  font-size: 30px;
  color: #f7ffff;
  margin-bottom: 42px;
}
.login-input-box {
  width: 100%;
  margin-bottom: 28px;
}
.login-input {
  width: 100%;
  border: none;
  border-bottom: 1px solid #253e53;
  outline: none;
  height: 60px;
  box-sizing: border-box;
  background-color: #0a1724;
  color: #657d92;
  font-size: 30px;
}
.login-input::placeholder {
  font-size: 18px;
}
.text-tips {
  display: inline-block;
  width: 100%;
  color: #7d97af;
  text-decoration-line: underline;
  cursor: pointer;
}
.btn-submit {
  width: 210px;
  height: 60px;
  color: #f7ffff;
  background: linear-gradient(to right, #8b68ff, #6160e8);
  border: none;
  font-size: 24px;
  border-radius: 80px;
  margin-top: 48px;
  cursor: pointer;
}
</style>
